/* eslint-disable import/no-default-export */
import { Action, actionCreator, createReducer } from '@trello/redux';

// Action types
const DISPLAY_SAVED_SEARCH_PROMO = Symbol('DISPLAY_SAVED_SEARCH_PROMO');
const HIDE_SAVED_SEARCH_PROMO = Symbol('HIDE_SAVED_SEARCH_PROMO');
const DISPLAY_ADD_SAVED_SEARCH_FORM = Symbol('DISPLAY_ADD_SAVED_SEARCH_FORM ');
const HIDE_ADD_SAVED_SEARCH_FORM = Symbol('HIDE_ADD_SAVED_SEARCH_FORM');

type DisplaySavedSearchPromoAction = Action<
  typeof DISPLAY_SAVED_SEARCH_PROMO,
  null
>;
type HideSavedSearchPromoAction = Action<typeof HIDE_SAVED_SEARCH_PROMO, null>;
type DisplayAddSavedSearchFormAction = Action<
  typeof DISPLAY_ADD_SAVED_SEARCH_FORM,
  null
>;
type HideAddSavedSearchFormAction = Action<
  typeof HIDE_ADD_SAVED_SEARCH_FORM,
  null
>;

// Reducer
export interface SearchUiState {
  displaySavedSearchPromo: boolean;
  displayAddSavedSearchForm: boolean;
  showAllTips: boolean;
}

const initialState: SearchUiState = {
  displaySavedSearchPromo: false,
  displayAddSavedSearchForm: false,
  showAllTips: false,
};

export default createReducer(initialState, {
  [DISPLAY_SAVED_SEARCH_PROMO](
    state: SearchUiState,
    { payload }: DisplaySavedSearchPromoAction,
  ) {
    return {
      ...state,
      displaySavedSearchPromo: true,
    };
  },
  [HIDE_SAVED_SEARCH_PROMO](
    state: SearchUiState,
    { payload }: HideSavedSearchPromoAction,
  ) {
    return {
      ...state,
      displaySavedSearchPromo: false,
    };
  },
  [DISPLAY_ADD_SAVED_SEARCH_FORM](
    state: SearchUiState,
    { payload }: DisplayAddSavedSearchFormAction,
  ) {
    return {
      ...state,
      displayAddSavedSearchForm: true,
    };
  },
  [HIDE_ADD_SAVED_SEARCH_FORM](
    state: SearchUiState,
    { payload }: HideAddSavedSearchFormAction,
  ) {
    return {
      ...state,
      displayAddSavedSearchForm: false,
    };
  },
});

export const displaySavedSearchPromo = actionCreator<DisplaySavedSearchPromoAction>(
  DISPLAY_SAVED_SEARCH_PROMO,
);

export const hideSavedSearchPromo = actionCreator<HideSavedSearchPromoAction>(
  HIDE_SAVED_SEARCH_PROMO,
);

export const displayAddSavedSearchForm = actionCreator<DisplayAddSavedSearchFormAction>(
  DISPLAY_ADD_SAVED_SEARCH_FORM,
);

export const hideAddSavedSearchForm = actionCreator<HideAddSavedSearchFormAction>(
  HIDE_ADD_SAVED_SEARCH_FORM,
);
